import { withErrorBoundary } from "@/components/hoc";
import { ResetForm } from "@/components/auth";

const Reset: React.FC = () => {
    return <ResetForm />;
};

export default withErrorBoundary({ component: "Reset" })(Reset);
